import { usePurchaseState } from './Purchase.hooks';
import { useInventory } from '../../Inventory/Inventory.hooks';
import { ActionIcon, Box, Center, Flex, Group, Menu, Stepper, Text, UnstyledButton } from '@mantine/core';
import classes from './Purchase.module.css';
import cx from 'clsx';
import SelectArrowsVariableIcon from '../../../components/icons/SelectArrows';
import ErrorFilledIcon from '../../../components/icons/ErrorFilled';
import CloseIcon from '../../../components/icons/Close';
import CheckCircleIcon from '../../../components/icons/CheckCircle';
import StadiumIcon from '../../../components/icons/Stadium';
import { Step_CatalogSelect } from './Purchase.Step.Catalog';
import ListIcon from '../../../components/icons/List';
import { Step_AddInventory } from './Purchase.Step.AddInventory';
import ReceiptIcon from '../../../components/icons/Receipt';
import { Step_Summary } from './Purchase.Step.Summary';

export function VL1PurchaseInterior() {
  const { active, setActive, selectedVendorId, setSelectedVendorId, vendors, selectedEvents, isSelectEventsEnabled, isVendorError } = usePurchaseState(
    'active',
    'setActive',
    'selectedVendorId',
    'setSelectedVendorId',
    'vendors',
    'selectedEvents',
    'isSelectEventsEnabled',
    'isVendorError',
  );

  const { closePurchaseModal } = useInventory('closePurchaseModal');

  const isMultiTenant = true; //(vendors?.length ?? 0) > 1;
  const dtiAccount = vendors?.find((x) => x.vendorId === selectedVendorId)?.displayName;

  return (
    <Flex direction="column" h="100%" w="100%" pos="relative">
      <Flex h="100%">
        <Flex className="col2" flex={1} direction="column" h="100%" style={{ borderRight: 'none' }}>
          <Flex h={52} align="center" pos="absolute" top={0} left={0} w={288}>
            <Menu disabled={!isMultiTenant} withArrow width={260} classNames={{ dropdown: classes.tenantMenu }}>
              <Menu.Target>
                {!isMultiTenant ? (
                  <UnstyledButton className={cx(classes.tenantButton, !isMultiTenant && 'tenant-single')} h={52} lts={-0.25} pl="md" pr="sm" w="100%">
                    <Box style={{ overflow: 'hidden' }}>
                      <Text fw="600" fz="sm" truncate flex={1} lh={1.3}>
                        {dtiAccount}
                      </Text>
                    </Box>
                    <Center className={classes.selectArrows}>
                      <SelectArrowsVariableIcon color="var(--colors-gray-5)" size={20} />
                    </Center>
                  </UnstyledButton>
                ) : (
                  <UnstyledButton className={cx(classes.tenantButton, isVendorError && classes.tenantButtonError)} h={52} lts={-0.25} pl="md" pr="sm" w="100%">
                    <Box style={{ overflow: 'hidden' }}>
                      <Group gap={6}>
                        {isVendorError && <ErrorFilledIcon color="var(--colors-red-error)" />}
                        <Text fw="600" fz="sm" truncate flex={1} lh={1.3}>
                          {selectedVendorId ? dtiAccount : 'Select an account'}
                        </Text>
                      </Group>
                    </Box>
                    <Center className={classes.selectArrows}>
                      <SelectArrowsVariableIcon color="var(--colors-gray-5)" size={20} />
                    </Center>
                  </UnstyledButton>
                )}
              </Menu.Target>
              <Menu.Dropdown mah={240} style={{ overflowY: 'auto' }}>
                {vendors?.map((vendor) => (
                  <Menu.Item
                    key={vendor.vendorId}
                    onClick={() => setSelectedVendorId(vendor.vendorId)}
                    className={cx(selectedVendorId === vendor.vendorId && classes.tenantSelected)}
                  >
                    {vendor.displayName}
                  </Menu.Item>
                ))}
              </Menu.Dropdown>
            </Menu>
          </Flex>
          <Flex h={52} align="center" justify="end" pos="absolute" top={0} right={0} w={288} px="xs">
            <ActionIcon m={0} onClick={() => closePurchaseModal()}>
              <CloseIcon size={24} />
            </ActionIcon>
          </Flex>
          <Stepper
            active={active}
            onStepClick={setActive}
            size="xs"
            className={classes.stepper}
            classNames={{ root: classes.stepper_root, content: classes.stepper_content, steps: classes.stepper_steps, separator: classes.stepper_separator }}
            completedIcon={<CheckCircleIcon />}
          >
            {isSelectEventsEnabled && (
              <Stepper.Step label="Select Events" withIcon icon={<StadiumIcon size={18} />}>
                <Step_CatalogSelect />
              </Stepper.Step>
            )}
            <Stepper.Step
              label="Add Inventory"
              withIcon
              icon={<ListIcon size={18} />}
              disabled={selectedEvents.length === 0}
              style={{
                cursor: selectedEvents.length === 0 ? 'default' : 'unset',
              }}
            >
              <Step_AddInventory />
            </Stepper.Step>
            <Stepper.Step
              label="Summary"
              withIcon
              icon={<ReceiptIcon size={18} />}
              disabled={selectedEvents.length === 0}
              style={{
                cursor: selectedEvents.length === 0 ? 'default' : 'unset',
              }}
            >
              <Step_Summary />
            </Stepper.Step>
          </Stepper>
        </Flex>
      </Flex>
    </Flex>
  );
}
